// NATIVE
import React, { useEffect, useState } from 'react';


// INSTALLED
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes, BrowserRouter } from 'react-router-dom';


// CUSTOM
import { login } from '../store/auth';
import { PublicRoutes } from './PublicRoutes';
import { Preload } from '../components/Preload';
import { PrivateRoutes } from './PrivateRoutes';
import { ProtectedRoute } from './ProtectedRoute';
import { setPensionRedux } from '../store/pension';
import { IAuth, ILoading } from '../commons/interfaces';
import { useCheckToken  } from '../hooks/useCheckToken';
import { setPermissions, setUserPermissions } from '../store/permissions';
import { useAssignedUserPermissions, usePermissions } from '../hooks';
import { ModalSessionExpired } from '../components/generics/ModalSessionExpired';




export const Navigator = () => {


  const dispatch = useDispatch();

  // REDUX
  const initialState   = useSelector( ( state:IAuth) => state.auth );
  const { status }:any  = useSelector( (state:ILoading) => state.loading );


  const [ initCheckToken ] = useCheckToken();
  const [ initCheckPermissons ] = usePermissions();
  const [isLogged,   setIsLogged] = useState<any>(undefined)
  const [ initCheckAssignedUserPermissions ] = useAssignedUserPermissions();
  
  

  useEffect(() => {
      checkToken();
  }, [initialState]);


  useEffect(() => {
      checkPermissons();
  }, [initialState]);


  useEffect(() => {
    checkAssignedUserPermissons();
  }, [initialState]);



  window.addEventListener("offline", (event:any) => {
     console.log('vaaaaaaaaaaa offline')
  });

  window.addEventListener("online", (event:any) => {
    console.log('vaaaaaaaaaaa online')
  });


  const checkToken = async () => {

    const user:any = await initCheckToken();

    
   if(user.token) {
      setIsLogged(true);
      await dispatch( login( user ));
    }else{
      setIsLogged(false);
    } 
    
  }


  const checkPermissons =  async () => {

    const permissions:any = await initCheckPermissons();

    await dispatch( setPermissions(permissions) );

  }

  const checkAssignedUserPermissons =  async () => {

    const permissions:any = await initCheckAssignedUserPermissions();

    await dispatch( setUserPermissions(permissions) );
    
  }




  return (
    <>

      {
        status  === 'checking'  && <Preload/>
      }
      
      
     
      <BrowserRouter> 
        <Routes>
          {
            ( isLogged )
            ? 
            
            <Route element={<ProtectedRoute user={isLogged} />}>
                
                <Route path="/*" element={<PrivateRoutes />} />
            </Route>
            :
            <Route path="/*" element={<PublicRoutes/>}/>
          }
        </Routes>
      </BrowserRouter>
    </>
  )
}